import { apiClient, requestData } from '@/api/client'
import type { LoginPayload, LoginRequest, LoginResult } from '@/types/auth'
import { hashLegacyPassword } from '@/utils/password'

export function buildLoginRequest(payload: LoginPayload): LoginRequest {
  return {
    username: payload.username,
    password: hashLegacyPassword(payload.password),
    dttype: 'Admin',
  }
}

export function login(payload: LoginPayload): Promise<LoginResult> {
  return requestData(apiClient.post('/tbk/admin/v2/user/login', buildLoginRequest(payload)))
}
